import { StyledInputBox } from "./styled";
import { StyledFormError } from "../../styles/ErrorMessage";

const SelectBox = ({label, name, register, errors, children})=>{
    return (
        <StyledInputBox>
            <label htmlFor={name}>{label}</label>
            <select {...register} id={name} className={errors && "invalidInput"}>
                {children}
            </select>
            {errors && <StyledFormError>{errors.message}</StyledFormError>}
        </StyledInputBox>

    )
    

}

export default SelectBox